var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendlyToneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.962,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8984 -0.0234375C11.6172 -0.0234375 12.336 -0.0234375 13.0547 -0.0234375C17.7315 0.583528 21.0674 3.02103 23.0625 7.28906C23.5376 8.45527 23.8423 9.65841 23.9766 10.8984C23.9766 11.6172 23.9766 12.336 23.9766 13.0547C23.3696 17.7315 20.9321 21.0674 16.6641 23.0625C15.4979 23.5376 14.2948 23.8423 13.0547 23.9766C12.336 23.9766 11.6172 23.9766 10.8984 23.9766C6.22158 23.3695 2.88565 20.932 0.890625 16.6641C0.415496 15.4979 0.110809 14.2947 -0.0234375 13.0547C-0.0234375 12.336 -0.0234375 11.6172 -0.0234375 10.8984C0.583528 6.22167 3.02103 2.88573 7.28906 0.890625C8.45527 0.415496 9.65841 0.110809 10.8984 -0.0234375ZM11.9297 1.38281C15.5384 1.48778 18.4212 2.97216 20.5781 5.83594C22.7123 9.01931 23.103 12.41 21.75 16.0078C20.2646 19.3523 17.7412 21.4539 14.1797 22.3125C10.2435 23.0108 6.89198 21.9249 4.125 19.0547C1.44752 15.8701 0.760022 12.2919 2.0625 8.32031C3.40908 4.92689 5.83875 2.73157 9.35156 1.73438C10.2071 1.53572 11.0664 1.41853 11.9297 1.38281Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.954,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00784 7.19531C8.65043 7.04334 9.79887 7.7152 10.4532 9.21094C10.5714 9.96769 10.2511 10.288 9.49221 10.1719C9.39439 10.1347 9.30842 10.08 9.2344 10.0078C9.09668 9.67762 8.91701 9.37294 8.69534 9.09375C7.976 8.50594 7.2416 8.47467 6.49221 9C6.20862 9.24656 6.01334 9.55125 5.90628 9.91406C5.50001 10.3515 5.09379 10.3515 4.68753 9.91406C4.528 9.57975 4.54362 9.25162 4.7344 8.92969C5.22532 7.99373 5.98315 7.41562 7.00784 7.19531Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.955,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8672 7.19531C17.428 7.02628 18.5609 7.63566 19.2656 9.02344C19.5335 9.65953 19.3381 10.0658 18.6797 10.2422C18.426 10.213 18.2151 10.1036 18.0469 9.91406C17.6667 8.86871 16.9401 8.47027 15.8672 8.71875C15.5562 8.84203 15.2984 9.03736 15.0938 9.30469C14.9626 9.57375 14.8142 9.83156 14.6484 10.0781C14.3359 10.2969 14.0235 10.2969 13.7109 10.0781C13.4885 9.83114 13.4182 9.54206 13.5 9.21094C13.9418 8.12733 14.7309 7.45547 15.8672 7.19531Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.956,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6172 14.7891C7.83667 14.7815 8.03978 14.8362 8.22657 14.9531C9.51775 16.9409 11.299 17.5815 13.5703 16.875C14.4812 16.4483 15.2 15.8077 15.7266 14.9531C16.1387 14.699 16.5059 14.7537 16.8281 15.1172C16.9844 15.3828 16.9844 15.6484 16.8281 15.9141C15.5402 17.8666 13.7199 18.765 11.3672 18.6094C9.52356 18.373 8.10948 17.4746 7.12501 15.9141C6.91956 15.3722 7.08362 14.9972 7.6172 14.7891Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendlyToneIcon);
export default __webpack_public_path__ + "static/media/friendly_tone_icon.56e38c48.svg";
export { ForwardRef as ReactComponent };